import React, { memo, useEffect , useState }   from 'react';
import { useTheme } from '@emotion/react';
import { Link, Typography, useMediaQuery } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import useSearchHours from 'src/SearchHours/hooks/useSearchHours';
import { filterSearchSelectedState, hoursAvailableState, loadingDaysCalendarState, loadingHoursState, professionalsMatchCovenantState, professionalsNoMatchCovenantState } from 'src/SearchHours/state/atoms';
import EmptyCalendar from 'src/shared/components/notFoundData/EmptyCalendar';
import { showModalEditFiltersState } from 'src/store/reservation/reservationState';
import CardProfessional from './CardProfessional';

const ListProfessionals = memo(() => {
    const theme = useTheme();
    const hoursAvailable = useRecoilValue(hoursAvailableState);
    const loadingHours = useRecoilValue(loadingHoursState);
    const loadingDaysCalendar = useRecoilValue(loadingDaysCalendarState)
    const { isEmptyFilters } = useSearchHours();
    const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
    const [professionalsMatchCovenant, setProfessionalsMatchCovenant] = useRecoilState(professionalsMatchCovenantState);
    const [professionalsNoMatchCovenant, setProfessionalsNoMatchCovenant] = useRecoilState(professionalsNoMatchCovenantState);
    
    const isMediaScreen = useMediaQuery(theme.breakpoints.down('md'));
    const setShowModalEditFilters = useSetRecoilState(showModalEditFiltersState);
    //const [loadingHours, setLoadingHours] = useState(false);
    const [professionalsSinBloque, setProfessionalsSinBloque] = useState([]);
    const [professionalsBloque, setProfessionalsBloque] = useState([]);

    const stylesTitles = {
        position: 'sticky',
        top: isMediaScreen ? '168px' : '68px',
        padding: '12px 0px 12px 0px',
        background: '#F4F6F8',
        zIndex: 12,
    };


    useEffect(() => {
        // pregunto si la prevision tiene valor, para buscar aquellos que coinciden y los que no
        if (filterSearchSelected.covenantSelected.value !== '' && hoursAvailable && hoursAvailable.length > 0) {
            // del resultado original, filtro aquellos que coinciden
            setProfessionalsMatchCovenant(hoursAvailable.filter(x => x.coincideConPrevision === true ))

            // del resultado original, filtro aquellos que no coinciden
            setProfessionalsNoMatchCovenant(hoursAvailable.filter(x => x.coincideConPrevision === false && x.horas[0].ageInicio !== "00:00"))
        }   

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hoursAvailable])

    useEffect(() => {

        console.log("----- PRESTADORES SIN HORA ------");
        //console.log(hoursAvailable);
        let result = hoursAvailable.filter(x => x.horas[0].ageInicio === "00:00")
        for (let i = 0; i < result.length; i++) {
            let newElement = result[i];
            setProfessionalsSinBloque(professionalsSinBloque => [...professionalsSinBloque, newElement])
        }
        
        console.log("----- PRESTADORES CON HORA ------");
        let result2 = hoursAvailable.filter(x => x.horas[0].ageInicio !== "00:00")

        for (let i = 0; i < result2.length; i++) {
            let horas = result2[i].horas;
            let resultHoras = horas.filter(x => x.ageCorrel !== 0)
            let myObject = {
                "ptdRut": result2[i].ptdRut,
                "horas": resultHoras,
                "ptdNombre": result2[i].ptdNombre,
                "especialidades": result2[i].especialidades,
                "convenios": result2[i].convenios,
                "imagen": result2[i].imagen,
                "valorParticular": result2[i].valorParticular,
                "fecha": result2[i].fecha,
                "sede": result2[i].sede,
                "indicacionesPaciente": result2[i].indicacionesPaciente,
                "ordenPorPrevision": result2[i].ordenPorPrevision,
                "coincideConPrevision": result2[i].coincideConPrevision,
                "agpCorrel": result2[i].agpCorrel,
            }
            setProfessionalsBloque(professionalsBloque => [...professionalsBloque, myObject])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hoursAvailable])

    if (isEmptyFilters()) {
        return (
            <EmptyCalendar
                mt={10}
                children={
                    <>
                        Para revisar nuestras ofertas médicas, por favor inicie su búsqueda
                        <Link
                            style={{
                                textDecoration: "none",
                                fontSize: "18px",
                                fontWeight: 700,
                                lineHeight: "18px",
                                fontStyle: 'italic'
                            }}
                            component="button"
                            variant="body2"
                            color="secondary"
                            onClick={() => setShowModalEditFilters(true)}
                        >
                            &nbsp;aquí
                        </Link>
                    </>
                }
            />
        )
    }

    // if (!loadingHours && !loadingDaysCalendar && hoursAvailable.length === 0) return <EmptyCalendar text={"No existe disponibilidad para los filtros seleccionados"} />
    
    return (
        <div>
            {
                professionalsMatchCovenant.length > 0 && filterSearchSelected.covenantSelected.value !== '' && (
                    <>
                        <Typography
                            variant='h5'
                            color={grey[700]}
                            fontWeight={700}
                            mb={2}
                            style={stylesTitles}
                        >
                            {professionalsMatchCovenant.length} coincidencia{professionalsMatchCovenant.length > 1 ? 's' : ''} con {filterSearchSelected.covenantSelected.value}
                        </Typography>
                        {
                            professionalsMatchCovenant.map((el, index) => (
                                <CardProfessional key={`professional_${index}`} professional={el} />
                            ))
                        }
                    </>
                )
            }
            {
                professionalsNoMatchCovenant.length > 0 && filterSearchSelected.covenantSelected.value !== '' && (
                    <>
                        <Typography
                            variant='h5'
                            color={grey[700]}
                            fontWeight={700}
                            mb={2}
                            style={stylesTitles}
                        >
                            {
                                professionalsNoMatchCovenant.every(x => x.convenios.length === 0) ?
                                    `Otros especialistas encontrados (${professionalsNoMatchCovenant.length})` :
                                    `${professionalsNoMatchCovenant.length} resultado${professionalsNoMatchCovenant.length > 1 ? 's' : ''} para otras previsiones`
                            }

                        </Typography>
                        {
                            professionalsNoMatchCovenant.map((el, index) => (
                                <CardProfessional key={`professional_${index}`} professional={el} />
                            ))
                        }
                    </>
                )
            }
            {
                    professionalsMatchCovenant.length === 0 && professionalsNoMatchCovenant.length === 0
                    && professionalsBloque.map((el, index) => (
                        <CardProfessional key={`professional_${index}`} professional={el} />
                    ))
            }
            {
               professionalsSinBloque.length > 0 && (
                <>
                    <Typography
                        variant='h5'
                        color={grey[700]}
                        fontWeight={700}
                        mb={2}
                        style={stylesTitles}
                    >
                        OTRAS FECHAS DISPONIBLES
                    </Typography>
                    {
                        professionalsSinBloque.map((el, index) => (
                            <CardProfessional key={`professional_${index}`} professional={el} />
                        ))
                    }
                </>
            )
            }

        </div>
    )
})

export default ListProfessionals;